import React, { useRef, useImperativeHandle } from 'react';
import SliderItem from './SliderItem';
import SliderContext from './SliderContext';
import useSlider from '../../../hooks/useSlide';

function Jumbotron (props, ref) {
  const refJumbotron = useRef(null);

  const {
    moveSlide,
    sliderIndex,
    sliderPages,
    bigPaginationIndicator,
    bigPaginationAutoButton,
    totalInViewport
  } = useSlider(refJumbotron, props.data.length, props.data, props.type, 3500, props.onChangeCurrentIndex);

  if (ref != null) {
    useImperativeHandle(ref, () => ({
      contentsSubspotTouch: (e) => {
        const testX = e.touches[0].clientX;

        moveSlide('onmouse_pause');

        setTimeout(() => { // 타이머 체킹
          const testTimeInX = testX;
          if (testTimeInX === testX) {
            moveSlide('play');
          }
        }, 200);
      }
    }));
  }

  const moveTouchPause = (e) => {
    const testX = e.touches[0].clientX;

    moveSlide('onmouse_pause');

    setTimeout(() => { // 타이머 체킹
      const testTimeInX = testX;
      if (testTimeInX === testX) {
        moveSlide('play');
      }
    }, 200);
  };

  let start_X = 0;
  let end_X = 0;
  const moveTouchSlide = (e) => { // 페이징 동작시점에 해당 함수 막기
    // 3. 해당 영역 부분 좌우 구분해서 페이징 처리 하기 좌 페이징  우페이징
    if (start_X == 0) {
      start_X = e.changedTouches[0].clientX;
    } else if (start_X != 0) {
      end_X = e.changedTouches[0].clientX;
    }

    if (start_X != 0 && end_X != 0) {
      const result = start_X - end_X;
      // //console.log('bbbbbbbbb');
      if (result > 0) {
        setTimeout(() => {
          moveSlide('right');
        }, 300); // 실제로 돌고 있는 슬라이드페이지들도 타이머를 가지고 있으므로 해당 타이머보다 적은 숫자로 세팅해야함
      } else if (result < 0) {
        setTimeout(() => {
          moveSlide('left');
        }, 300); // 실제로 돌고 있는 슬라이드페이지들도 타이머를 가지고 있으므로 해당 타이머보다 적은 숫자로 세팅해야함
      }
      start_X = 0;
      end_X = 0;
    }
  };

  return (
    <SliderContext.Provider value={[]}>
      <div className='event_topswipe_w' onTouchMove={(e) => moveTouchSlide(e)}>
        <ul className='event_topswipe_list' ref={refJumbotron}>
          {props.data.map((item, index) => {
            const sliderIndexViewStart = (sliderIndex * totalInViewport);
            const sliderIndexViewEnd = sliderIndexViewStart + totalInViewport;
            const isBetween = index >= sliderIndexViewStart && index < sliderIndexViewEnd;
            return (
              <SliderItem
                key={index}
                view={isBetween}
                slide_key={item.id || item.order_no || item.ord_no}
                {...item}
                index={index}
                currentIndex={sliderIndex}
                type='eventtopbox'
                moveTouchPause={moveTouchPause}
              />
            );
          })}
        </ul>

        <div className='mvs_paging_w'>
          <div className='mvs_paging_inner'>
            <ul className='mvsp_list_w'>
              {sliderPages > 1 ? (bigPaginationIndicator(sliderPages)) : ''}
            </ul>
            <>
              {sliderPages > 1 ? (bigPaginationAutoButton()) : ''}
            </>
          </div>

        </div>
      </div>
    </SliderContext.Provider>

  );
}
const forwardedRefInput = React.forwardRef(Jumbotron);
export default forwardedRefInput;
